var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1074.22 562.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-22 {\n        stroke: url(#linear-gradient-18);\n      }\n\n      .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31 {\n        fill: none;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-4, .cls-7, .cls-13, .cls-18, .cls-20 {\n        opacity: .19;\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-23 {\n        stroke: url(#linear-gradient-6);\n      }\n\n      .cls-23, .cls-28, .cls-29 {\n        stroke-width: 1.91px;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-24 {\n        stroke: url(#linear-gradient-17);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-25 {\n        stroke: url(#linear-gradient-5);\n        stroke-width: 2.84px;\n      }\n\n      .cls-25, .cls-30 {\n        stroke-linecap: round;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-26 {\n        stroke: url(#linear-gradient-31);\n      }\n\n      .cls-26, .cls-27, .cls-31 {\n        stroke-width: 2px;\n      }\n\n      .cls-27 {\n        stroke: url(#linear-gradient-27);\n      }\n\n      .cls-28 {\n        stroke: url(#linear-gradient-8);\n      }\n\n      .cls-29 {\n        stroke: url(#linear-gradient-7);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-26);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-30 {\n        stroke: url(#linear-gradient-9);\n        stroke-width: 1.82px;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-31 {\n        stroke: url(#linear-gradient-29);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 465.99,
    y1: 40.27,
    x2: 523.93,
    y2: 40.27,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7427e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#e53d75"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#df315e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#d71d38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d5182e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 422.27,
    x2: 480.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 380.21,
    x2: 438.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 307.1,
    y1: 679.69,
    x2: 767.13,
    y2: -117.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 306.33,
    y1: 681.01,
    x2: 767.89,
    y2: -118.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 463.67,
    y1: 40.28,
    x2: 526.23,
    y2: 40.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 419.95,
    y1: 40.28,
    x2: 482.51,
    y2: 40.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 377.89,
    y1: 40.28,
    x2: 440.46,
    y2: 40.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 614.65,
    y1: 544.88,
    x2: 919.01,
    y2: 17.71,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 615.14,
    y1: 544.03,
    x2: 918.52,
    y2: 18.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 747.87,
    y1: 4.2,
    x2: 750.12,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 736.99,
    y1: 4.2,
    x2: 739.24,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 724.99,
    y1: 4.2,
    x2: 727.24,
    y2: 0.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: -51.59,
    y1: 506.5,
    x2: 267.48,
    y2: -46.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 904.98,
    y1: 137.19,
    x2: 995.31,
    y2: -19.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 628.71,
    y1: 706.8,
    x2: 853.31,
    y2: 317.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 489.9,
    y1: 76,
    x2: 572.46,
    y2: -67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 225.78,
    y1: 609.9,
    x2: 281.58,
    y2: 513.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1068.32,
    y1: 264.11,
    x2: 1077.31,
    y2: 248.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 1068.32,
    y1: 287.86,
    x2: 1077.31,
    y2: 272.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 1068.32,
    y1: 311.61,
    x2: 1077.31,
    y2: 296.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 1068.32,
    y1: 335.36,
    x2: 1077.31,
    y2: 319.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 1068.32,
    y1: 359.11,
    x2: 1077.31,
    y2: 343.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 1068.32,
    y1: 382.86,
    x2: 1077.31,
    y2: 367.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 1068.32,
    y1: 406.61,
    x2: 1077.31,
    y2: 391.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 1068.32,
    y1: 430.36,
    x2: 1077.31,
    y2: 414.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 460.4,
    y1: 299.2,
    x2: 495.58,
    y2: 238.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 412.7,
    y1: 271.66,
    x2: 447.87,
    y2: 210.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 394.51,
    y1: 373.15,
    x2: 446,
    y2: 283.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 320.46,
    y1: 330.4,
    x2: 371.96,
    y2: 241.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 375.34,
    y1: 519.83,
    x2: 484.85,
    y2: 330.15,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "index"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "488.57 57.89 523.93 22.53 501.47 22.53 465.99 58.01 488.57 57.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "444.84 57.89 480.2 22.53 457.75 22.53 422.27 58.01 444.84 57.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "402.79 57.89 438.15 22.53 415.69 22.53 380.21 58.01 402.79 57.89"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1010.65,23.49h-470.65l-44.22,44.22-336.81-.81-43.42-43.42h-51.96c-16.11,16.11-25.14,25.14-41.25,41.25v433.1c16.11,16.11,25.14,25.14,41.25,41.25h947.07c16.11-16.11,25.14-25.14,41.25-41.25V64.75c-16.11-16.11-25.14-25.14-41.25-41.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M1010.65,23.49h-470.65l-44.22,44.22-336.81-.81-43.42-43.42h-51.96c-16.11,16.11-25.14,25.14-41.25,41.25v433.1c16.11,16.11,25.14,25.14,41.25,41.25h947.07c16.11-16.11,25.14-25.14,41.25-41.25V64.75c-16.11-16.11-25.14-25.14-41.25-41.25Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "488.57 57.89 523.93 22.53 501.47 22.53 465.99 58.01 488.57 57.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "444.84 57.89 480.2 22.53 457.75 22.53 422.27 58.01 444.84 57.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "402.79 57.89 438.15 22.53 415.69 22.53 380.21 58.01 402.79 57.89"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M983.31,506.63h-432.96c-10.35-10.35-16.15-16.15-26.5-26.5V82.46c10.35-10.35,16.15-16.15,26.5-26.5h432.96c10.35,10.35,16.15,16.15,26.5,26.5v397.67c-10.35,10.35-16.15,16.15-26.5,26.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M983.31,506.63h-432.96c-10.35-10.35-16.15-16.15-26.5-26.5V82.46c10.35-10.35,16.15-16.15,26.5-26.5h432.96c10.35,10.35,16.15,16.15,26.5,26.5v397.67c-10.35,10.35-16.15,16.15-26.5,26.5Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 748.99,
    cy: 2.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 738.12,
    cy: 2.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 726.12,
    cy: 2.25,
    r: 2.25
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "132.33 558.56 45.07 558.56 3.01 514.85 3.01 47.74 45.07 4.03 347.73 4.03 349.18 1.02 43.79 1.02 0 46.53 0 516.06 43.79 561.57 129.79 561.57 132.33 558.56"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "1071.21 47.74 1071.21 233.16 1074.22 230.14 1074.22 46.53 1030.44 1.02 760.69 1.02 759.58 4.03 1029.15 4.03 1071.21 47.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "1071.21 447.28 1071.21 514.85 1029.15 558.56 379.68 558.56 377.17 561.57 1030.44 561.57 1074.22 516.06 1074.22 445.32 1071.21 447.28"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "cls-24",
    x1: 366.93,
    y1: 4.5,
    x2: 695.43,
    y2: 4.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-22",
    x1: 142.93,
    y1: 561.57,
    x2: 364.43,
    y2: 561.57
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "1071.42 249.59 1071.42 265.89 1074.22 263.05 1074.22 246.75 1071.42 249.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "1071.42 273.34 1071.42 289.64 1074.22 286.8 1074.22 270.5 1071.42 273.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "1071.42 297.09 1071.42 313.39 1074.22 310.55 1074.22 294.25 1071.42 297.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "1071.42 320.84 1071.42 337.14 1074.22 334.3 1074.22 318 1071.42 320.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "1071.42 344.59 1071.42 360.89 1074.22 358.05 1074.22 341.75 1071.42 344.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "1071.42 368.34 1071.42 384.64 1074.22 381.8 1074.22 365.5 1071.42 368.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "1071.42 392.09 1071.42 408.39 1074.22 405.55 1074.22 389.25 1071.42 392.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "1071.42 415.84 1071.42 432.14 1074.22 429.3 1074.22 413 1071.42 415.84"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-27",
    points: "445.54 214.54 445.54 281.29 464.68 300.43 523.86 300.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M440.73,214.78c0-2.66,2.15-4.81,4.81-4.81s4.81,2.16,4.81,4.81-2.16,4.81-4.81,4.81-4.81-2.16-4.81-4.81Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-31",
    x1: 519.79,
    y1: 327.57,
    x2: 321.86,
    y2: 327.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M322.1,322.76c-2.66,0-4.81,2.16-4.81,4.81s2.16,4.81,4.81,4.81,4.81-2.16,4.81-4.81-2.15-4.81-4.81-4.81Z"
  })), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-26",
    points: "519.79 351.32 438.15 351.32 409.72 379.75 409.72 539.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.3b35eb2aaaa474880e34b3f43a2d9886.svg";
export { ForwardRef as ReactComponent };